// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TReceiptDetailsSaveRequest,
  TReceiptDetailsSaveModel,
  IMappers,
  TReceiptDetailsSaveResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicV1ReceiptDetailsSaveResponse } from '../../../entities/response/PublicV1ReceiptDetailsSaveResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createReceiptDetailsSaveModel(parameters: TReceiptDetailsSaveRequest): TReceiptDetailsSaveModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v1/receipt-details/save/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IReceiptDetailsSaveOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TReceiptDetailsSaveRequest;
}

export async function fetchReceiptDetailsSave<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IReceiptDetailsSaveOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TReceiptDetailsSaveResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createReceiptDetailsSaveModel(parameters),
    config,
  )) as FetchResponse<TReceiptDetailsSaveResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicV1ReceiptDetailsSaveResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TReceiptDetailsSaveResponse>;
}
